<template>
	<div class="grid-flex-container" v-if="initialized">
		<v-container
			fluid
			class="d-flex flex-column flex-wrap flex-grow-1 overflow-y-auto"
		>
			<edit-user-fields
				:selectedUser="selectedUser"
				:adminFields="false"
				@cancel="cancel"
				@submit="submit"
			/>
			<user-project-assignment
				v-if="this.$route.params.id"
				:showDialog="showDialog"
				@cancel="hideModal"
			/>
			<user-project-permission-assignment
				v-if="this.$route.params.id"
				:showDialog="showPermissionDialog"
				@cancel="hidePermissionModal"
			/>
		</v-container>

		<v-container fluid class="align-end">
			<v-row no-gutters>
				<v-btn
					v-if="this.$route.params.id && canAssignProjects"
					color="primary"
					class="mr-2"
					@click="showModal"
					>Assign user to projects</v-btn
				>
				<v-btn
					v-if="this.$route.params.id && canEditPermissions"
					color="primary"
					@click="showPermissionModal"
					>Edit Permissions</v-btn
				>
				<v-spacer />
				<v-btn color="" @click="onCancel" class="mr-2">Cancel</v-btn>
				<v-btn color="primary" @click="onSubmit">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Submit
				</v-btn>
			</v-row>
		</v-container>
	</div>
</template>
<script>
import { ClientUserManagementGetters } from '../../../store/getters';
import { ClientUserManagementActions } from '../../../store/actions';
import EditUserFields from './EditUserFields.vue';
import { mapGetters } from 'vuex';
import UserProjectAssignment from './UserProjectAssignment.vue';
import UserProjectPermissionAssignment from './UserProjectPermissionAssignment.vue';
import { Permissions } from '../../../enums/permissionsEnum';
import permissionsMixin from '../../../mixins/permissionsMixin';
export default {
	name: 'ClientUserManagementEdit',
	mixins: [permissionsMixin],
	data() {
		return {
			showDialog: false,
			showPermissionDialog: false,
			initialized: false,
		};
	},
	components: {
		EditUserFields,
		UserProjectAssignment,
		UserProjectPermissionAssignment,
	},
	computed: {
		...mapGetters({
			selectedUser: [ClientUserManagementGetters.GET_SELECTED_USER],
		}),
		canAssignProjects() {
			return this.hasPermissions([
				Permissions.Tools.UserManagement.AssignToProject,
			]);
		},
		canEditPermissions() {
			return this.hasPermissions([
				Permissions.Tools.UserManagement.EditPermissions,
			]);
		},
	},
	mounted() {
		if (this.$route.params.id) {
			this.$store
				.dispatch(
					ClientUserManagementActions.LOAD_DATA_BYUSERID,
					this.$route.params.id
				)
				.then(() => {
					this.initialized = true;
				});
		} else {
			this.initialized = true;
		}
	},
	destroyed() {},
	methods: {
		onCancel() {
			this.$children[0].onCancel();
		},
		onSubmit() {
			this.$children[0].onSubmit();
		},

		showModal() {
			this.showDialog = true;
		},
		showPermissionModal() {
			this.showPermissionDialog = true;
		},
		hideModal() {
			this.showDialog = false;
		},
		hidePermissionModal() {
			this.showPermissionDialog = false;
		},

		cancel() {
			this.$router.push({
				name: 'UserManagement',
			});
		},
		submit(formUser) {
			if (formUser.Id) {
				this.$store.dispatch(
					ClientUserManagementActions.UPDATE,
					formUser
				);
				this.$router.push({
					name: 'UserManagement',
				});
			} else {
				this.initialized = false;
				this.$store
					.dispatch(ClientUserManagementActions.INSERT, formUser)
					.then(() => {
						this.$router
							.push({
								name: 'ClientUserManagementEdit',
								params: { id: this.selectedUser.Id },
							})
							.then(() => {
								this.initialized = true;
							});
					});
			}
		},
	},
};
</script>
